<template>
    <Modal ref="modal" class="order-history-modal" @closed="onCloseModal">
        <template #button="sp">
            <slot name="button" :show-modal="showModal"></slot>
        </template>
        <template #body="sp">
            <div v-if="loading">
                <i class="fad fa-spinner fa-spin"></i> Chargement de l'historique
            </div>
            <div v-else>
                <div class="mb-2 d-flex align-items-center justify-content-between">
                    <span class="h4">
                        Historique de la commande {{ order.reference }} à {{ global.moment().format('HH:mm:ss') }}
                        <template v-if="product">
                            <div class="product">Produit {{ product.tiny_name }}</div>
                        </template>
                    </span>
                    <button class="btn btn-success mb-2" @click="loadHistory()">
                        <i class="fad fa-sync"></i> Rafraîchir
                    </button>
                </div>

                <ErrorsZone v-if="errors" :errors="errors"/>
                <table v-else-if="histories.length" class="table table-sm table-condensed table-striped">
                    <tbody>
                        <OrderHistoryModalMessage v-for="history in histories" :key="history.id" :history="history" :now="now" :order="order" />
                    </tbody>
                </table>
                <div v-else class="alert alert-info">
                    Aucun historique pour le moment
                </div>

                <div class="mt-2">
                    <button class="btn btn-success mb-2" @click="loadHistory()">
                        <i class="fad fa-sync"></i> Rafraîchir
                    </button>
                </div>
            </div>
        </template>
        <template #footer="sp">
            <button class="btn btn-secondary" @click="sp.closeModal()">Fermer</button>
        </template>
    </Modal>
</template>

<script>
    import ErrorsZone from "./ErrorsZone";
    import Modal from "./Modal";
    import OrderHistoryModalMessage from "./OrderHistoryModalMessage"

    import {useGetLoader} from "./compositions/axios/loadingRequest";

    export default {
        components: {
            ErrorsZone,
            Modal,
            OrderHistoryModalMessage,
        },

        setup() {
            const {
                loading,
                errors,
                load,
            } = useGetLoader();

            return {
                loading,
                errors,
                load,
            };
        },

        props: {
            order: {
                type: Object,
                required: true,
            },
            product: {
                type: Object,
                required: false,
            },
        },

        data() {
            return {
                histories: [],
                now: global.moment().toDate(),
            };
        },

        async mounted() {
            setInterval(() => {
                this.now = global.moment().toDate();
            }, 30000);
        },

        methods: {
            async loadHistory() {
                this.histories = [];

                if(this.order.id) {
                    if (this.order.is_recurrent) {
                        this.histories = await this.load(`/espace-employes/commandes/commande-magasin-recurrente/${this.order.id}/historique`);
                    } else {
                        if (this.product) {
                            this.histories = await this.load(`/espace-employes/commandes/${this.order.id}/produit/${this.product.sku}/historique`);
                        } else {
                            this.histories = await this.load(`/espace-employes/commandes/${this.order.id}/historique`);
                        }
                    }
                }
            },

            async showModal() {
                this.$refs.modal.showModal();

                await this.loadHistory();
            },

            closeModal() {
                this.histories = [];
                this.$refs.modal.closeModal();
            },

            onCloseModal() {
                this.$emit('closed');
            },
        },
    }
</script>

<style lang="scss">
    .order-history-modal {
        .modal-container {
            max-width: 90%;
            width: auto;
        }
    }
</style>
